<template>
  <b-card
    img-src="img/login-bg.jpg"
    img-alt="Image"
    img-top
    tag="article"
    class="mb-2"
  >
    <b-form>

      <h5 class="text-muted pb-3">
        <span>A new password is required to continue.</span>
      </h5>

      <p class="alert alert-warning" v-if="error">{{error}}</p>

<!--      <p class="text-muted">A new password is required to continue.</p>-->

      <b-input-group class="mb-4">
        <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
        <b-form-input type="password" class="form-control" placeholder="New password" autocomplete="new-password"  v-model="password" />
      </b-input-group>

      <b-input-group class="mb-4">
        <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
        <b-form-input type="password" class="form-control" placeholder="Confirm password" autocomplete="confirm-password"  v-model="password_confirm" />
      </b-input-group>

      <b-button variant="success" block @click="onSubmit">Submit</b-button>

    </b-form>
  </b-card>
</template>

<script>
import {AUTH_SET_NEW_PASSWORD,AUTH_LOGIN} from '@/store/action-types';
export default {
  name: 'NewPasswordForm',
  props: ['username'],
  data() {
    return {
      password: null,
      password_confirm: null,
      error: null,
    }
  },
  methods: {
    onSubmit() {
      if(this.password === this.password_confirm) {
        this.$store.dispatch(AUTH_SET_NEW_PASSWORD, {username: this.username, 'password': this.password}).then(() => {
          this.signIn();
        }).catch(() => {
          const error = this.$store.getters.getAuthenticationError;
          if(error) {
            this.error = error
          } else {
            this.error = 'Something went wrong please contact an administrator';
          }
        });
      } else {
        this.error = 'Passwords do not match';
      }
    },
    signIn() {
      const username = this.username;
      const password = this.password;
      this.error_msg = null;
      this.$store.dispatch(AUTH_LOGIN, {username, password}).then(() => {
        const status = this.$store.getters.getAuthenticationStatus;
        if(status === 'sign_in__success') {
          this.$router.push('/dashboard');
        }
      }).catch(() => {
        const error = this.$store.getters.getAuthenticationError;
        if(error) {
          this.error_msg = error
        } else {
          this.error_msg = 'Something went wrong please contact an administrator';
        }
        this.logging_in = false;
      });
    }
  },
  mounted() {
    if(!this.username) {
      this.$emit('clearPasswordReset')
    }
  }
}
</script>
